import { i18n } from '@migros/msrc-i18n';
import { isPropValid, media, styled } from '@migros/msrc-ui-kit';
import React from 'react';
import { useI18n } from '../../../hooks/use-i18n';
export const StackedBadge = ({
  badge_details,
  conditions,
  package_description,
  language,
  horizontal = false
}) => {
  useI18n(language);
  return /*#__PURE__*/React.createElement(Wrapper, {
    horizontal: horizontal
  }, getBadges(badge_details, horizontal, conditions, package_description).slice(-MAX_BADGES).map((badge, index) => {
    return /*#__PURE__*/React.createElement(Badge, {
      key: `badge_${index}`,
      background: badge.background,
      "data-testid": "msrc-articles--article-badge"
    }, badge.text);
  }));
};
var ReductionType = /*#__PURE__*/function (ReductionType) {
  ReductionType["relativeDiscount"] = "01";
  ReductionType["absoluteDiscount"] = "02";
  ReductionType["cumulus"] = "05";
  ReductionType["discountPrice"] = "06";
  ReductionType["hit"] = "07";
  return ReductionType;
}(ReductionType || {}); // Hit
const MAX_BADGES = 3;
const getBadges = (badge_details, horizontal, conditions, package_description) => {
  const badges = [];
  const {
    reduction_type_id,
    hex_color,
    description
  } = badge_details;
  if (reduction_type_id === ReductionType.cumulus) {
    var _description$match;
    badges.push({
      text: i18n.t('components.badges.new'),
      background: hex_color
    });
    badges.push({
      text: `${(_description$match = description.match(/\d/g)) === null || _description$match === void 0 ? void 0 : _description$match.join('')}x`,
      background: '#003D8C' // only on TEST this value is provided by the api via badge_details.signet.hex_color,
    });
  }
  if (conditions) {
    badges.push({
      text: `${i18n.t('components.badges.from')} ${conditions.minimum_pieces.value} ${i18n.t('components.badges.amount')}`,
      background: '#333'
    });
  } else if (package_description) {
    badges.push({
      text: package_description,
      background: '#333'
    });
  }
  switch (reduction_type_id) {
    case ReductionType.hit:
      badges.push({
        text: description,
        background: hex_color
      });
      break;
    case ReductionType.relativeDiscount:
      badges.push({
        text: badge_details.discount_amount,
        background: hex_color
      });
      break;
    case ReductionType.absoluteDiscount:
      badges.push({
        text: joinTextForAbsoluteDiscount(getAmount(description), !description.includes('.'), horizontal, description.includes(i18n.t('components.badges.franc'))),
        background: hex_color
      });
      break;
    case ReductionType.discountPrice:
      badges.push({
        text: badge_details.description,
        background: hex_color
      });
      break;
    default:
      break;
  }
  return badges;
};
const Wrapper = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  display: grid;
  ${({
  horizontal
}) => horizontal ? 'grid-auto-flow: column;' : 'grid-auto-flow: row;'}
  grid-auto-columns: minmax(min-content, max-content);
  ${media.tabletAndDown`
    width: 100vw;
    grid-auto-flow: column;
  `}
`;
const Badge = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  font-family: ${({
  theme: {
    fonts
  }
}) => fonts.families.articleText};
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 800;
  line-height: 16px;
  color: #fff;
  min-height: 20px;
  min-width: 56px;
  overflow-wrap: break-word;
  padding: 2px 4px;
  background-color: ${({
  background
}) => background ? background : '#f60'};
  ${media.tabletAndDown`
    line-height: 12px;
    min-height: 16px;
    min-width: 48px;
    font-size: 12px;
  `}
`;
const TextWrapper = styled.div.withConfig({
  shouldForwardProp: isPropValid
})`
  display: flex;
  ${({
  horizontal
}) => horizontal ? 'flex-direction: row;' : 'flex-direction: column;'}
  ${media.tabletAndDown`
    flex-direction: row;
  `}
`;
const Text = styled.span.withConfig({
  shouldForwardProp: isPropValid
})`
  font-weight: 800;
  line-height: 16px;
  color: #fff;
  text-align: center;
  ${({
  horizontal
}) => horizontal && `
    :nth-of-type(2) {
      margin-left: 4px;
    }
  `}
  ${media.tabletAndDown`
    line-height: 12px;
    :nth-of-type(2) {
      margin-left: 4px;
    }
  `}
`;
const getAmount = text => {
  const amount = text.match(/^\d+(\.\d{1,2})?/);
  return amount ? amount[0] : '0';
};
const joinTextForAbsoluteDiscount = (amount, hasCurrency, horizontal, isFranken) => {
  let currency;
  if (hasCurrency) {
    if (isFranken === undefined) {
      return i18n.t('components.badges.error');
    }
    currency = isFranken ? /*#__PURE__*/React.createElement(Text, {
      horizontal: horizontal
    }, `${amount}.-`) : /*#__PURE__*/React.createElement(Text, {
      horizontal: horizontal
    }, `-.${amount}`);
  } else {
    currency = amount;
  }
  return /*#__PURE__*/React.createElement(TextWrapper, {
    horizontal: horizontal
  }, currency, /*#__PURE__*/React.createElement(Text, {
    horizontal: horizontal
  }, i18n.t('components.badges.discount')));
};